module.exports = __webpack_public_path__ + "static/media/sample4.e6bfd6f2.jpg";